import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q6: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'interiorPackages', 'steeringWheels'],
	nextBestActions: [
		{
			icon: '',
			description: 'Få din brugte bil vurderet',
			labelText: 'Få din brugte bil vurderet',
			target: '_blank',
			trackingName: 'request a trade-in appraisal',
			url: 'https://ww2.audi.dk/brugtbilsvurdering',
		},
	],
};

const sq6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q6etron, q6etron_ui, sq6etron, sq6etron_ui };
